"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  item: {
    background: "none",
    border: "0 none",
    borderRadius: "50%",
    color: theme.palette.background.infoAZItem,
    cursor: "pointer",
    display: "block",
    height: 24,
    lineHeight: 2,
    marginBottom: theme.spacing(0.5),
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: theme.spacing(0.5),
    padding: 0,
    transition: "all 500ms ease",
    width: 24,
    "&:last-child": {
      marginBottom: theme.spacing(1.5)
    },
    "& span": {
      ...theme.customTypography.infoAZLabel
    },
    [theme.breakpoints.up("lg")]: {
      "&:last-child": {
        marginBottom: theme.spacing(4.5)
      }
    }
  },
  itemDisabled: {
    cursor: "default",
    opacity: 0.3,
    "&:hover": {
      background: "none",
      color: theme.palette.background.infoAZItem
    }
  },
  itemHover: {
    "&:hover": {
      background: theme.palette.background.light
    }
  },
  itemSelected: {
    background: "".concat(theme.palette.primary.main, " !important"),
    color: "".concat(theme.palette.common.white, " !important")
  }
}));
const SectionFilterItem = _ref => {
  let {
    disabled,
    item,
    selected,
    onChange
  } = _ref;
  const {
    id,
    title
  } = item;
  const css = useStyles();
  const handleChange = item => {
    onChange(item);
  };
  return /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _clsx.default)({
      [css.item]: true,
      [css.itemDisabled]: disabled,
      [css.itemHover]: !("ontouchstart" in document.documentElement),
      [css.itemSelected]: selected
    }),
    key: id,
    "data-item": JSON.stringify(item),
    disabled: disabled,
    onClick: () => handleChange(item)
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "span",
    variant: "body2"
  }, title));
};
var _default = exports.default = SectionFilterItem;